import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';
import { Activity } from '@ispm-shared/modules/bpmn';

const getExecutedActivities = (state: State): any => state.executedActivities;

export const selectExecutedActivities: MemoizedSelector<
  object,
  Activity[]
  > = createSelector(selectBpmnProcessState, getExecutedActivities);
